import React, { useState, useEffect } from "react";
import { Stack, Box, Input, styled, Button } from "@mui/material";
import { theme, Badge } from "@material-ui/core";
import axios from "axios";
import Select from "react-select";


const TXTRoundedDiv = styled("div")(({theme})=>({
   borderRadius: theme.shape.borderRadius,
   border: "1px solid #6BD5C0",
   marginLeft: "5px",
   width: "100%",
   marginBottom: "10px"
}));

const StyledBox = styled(Box)({
    marginLeft: "5px",
    marginRight: "5px",
    marginBottom: "5px",
});

const StyledInput = styled(Input)({
  fontSize: "14px",
  height: "95%",
  width: "100%",
  marginTop: "2px",
  marginBottom: "2px",
});


export default function FormUsers (props) {
    
    const [errors, setErrors]=useState({});
    
    const [formData, setFormData]=useState({
        username: '',
        email: '',
        password: '',
        repassword: '',
        mobile_no: '',

    })
    
    const handleChangeInput = (e) =>{
      const { name , value } = e.target;

      setFormData({
        ...formData,
        [name]: value
       })
    }

    const handleButtonSubmit = () =>{

        let newErrors=validateForm(formData);
        setErrors(newErrors);
        
        console.log("formData.username=" + formData.username);
        console.log("formData.email=" + formData.email);
        console.log("formData.mobile_no=" + formData.mobile_no);
        console.log("formData.password=" + formData.password);
        console.log("formData.repassword=" + formData.repassword);
        

    }

    const validateForm = (data) =>{
         const errors={};
         let regExp=/^[a-zA-Z0-9._]+@[a-z]+\.[a-z]{2-6}$/;
         
         let regExpPassword=/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,10})/

         if(!data.username.trim()){
          errors.username='Please enter username';
         }

         if(!data.email.trim()){
            errors.email='Please enter email';
        }
        ///     (!/\S+@\S+\.\S+/.test(data.email)
        ///       /.+@.+\.[A-Za-z]+$/
        ///       /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/
        ///       /^[a-zA-Z0-9]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/
        ///       /^[a-zA-Z0-9._]+@[a-z]+\.[a-z]{2-6}$/
        else if (!regExp.test(data.email)) {
        errors.email = 'Email is invalid';
        }
        else{
        
        }
        
        if(!data.password.trim()){
            errors.password='Please enter password';
        }

        if(!data.repassword.trim()){
            errors.repassword='Please re enter password';
         }
         
         if(data.repassword.trim()!==data.password.trim()){
            errors.repassword='Passwords do not match';
         }
          
         if(!regExpPassword.test(data.password.trim()) || (data.password.trim().length<8)){
            errors.password='Password must contains atleast 8 characters,including numbers, small and capital letters,and special characters';
         }
        

         if(!data.mobile_no.trim()){
            errors.mobile_no='Please enter mobile no';
        }

         return errors;
    }
    
    return(
   <Stack direction="row" spacing={1}>
     <StyledBox flex={4}>
      
      <TXTRoundedDiv>
        <StyledInput 
        name="username"
        placeholder="Username"
        onChange={handleChangeInput}

        />
        {errors.username && (<span>{errors.username}</span>)}
      </TXTRoundedDiv> 

      <TXTRoundedDiv>
        <StyledInput 
        name="mobile_no"
        placeholder="Mobile Number"
        onChange={handleChangeInput}

        />
        {errors.mobile_no && (<span>{errors.mobile_no}</span>)}
      </TXTRoundedDiv>

      <TXTRoundedDiv>
        <StyledInput 
        name="email"
        placeholder="Email"
        onChange={handleChangeInput}
        
        />
        {errors.email && (<span>{errors.email}</span>)}
      </TXTRoundedDiv> 

      <TXTRoundedDiv>
        <StyledInput 
        type="password"
        name="password"
        placeholder="Password"
        onChange={handleChangeInput}
        
        />
        {errors.password && (<span>{errors.password}</span>)}
      </TXTRoundedDiv> 

      <TXTRoundedDiv>
        <StyledInput 
        type="password"
        name="repassword"
        placeholder="Retype Password"
        onChange={handleChangeInput}
        
        />
        {errors.repassword && (<span>{errors.repassword}</span>)}
      </TXTRoundedDiv> 
      
      <Button type="Submit"  color="secondary" variant="contained" onClick={handleButtonSubmit}>
       SAVE
      </Button>
     </StyledBox>

     <StyledBox flex={4}>

     </StyledBox>

     <StyledBox flex={4}>

     </StyledBox>
   </Stack>
    )
}